import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-more-detail-dialog',
  templateUrl: './more-detail-dialog.component.html',
  styleUrls: ['./more-detail-dialog.component.scss']
})
export class MoreDetailDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialogRef: MatDialogRef<MoreDetailDialogComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(null);
  }
}
